export default __webpack_public_path__ + "static/media/ibiza.f20a79fc.jpg";